var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgViewList = function SvgViewList(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17V7q0-.824.587-1.412A1.93 1.93 0 0 1 5 5h14q.824 0 1.413.588Q21 6.175 21 7v10q0 .824-.587 1.413A1.93 1.93 0 0 1 19 19H5q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 17m2-8h2V7H5zm4 0h10V7H9zm0 4h10v-2H9zm0 4h10v-2H9zm-4 0h2v-2H5zm0-4h2v-2H5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgViewList);
export { ForwardRef as ReactComponent };